import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'INR',
    enableAlternativeAvailabilityCheck: true,
    includeVAT: true,
    measurement: 'both',
    enableEnergyLabelLink: true,
};
